export default __webpack_public_path__ + "static/media/insta.6030a881.png";